import { render, staticRenderFns } from "./CourseUpload.vue?vue&type=template&id=c49c042e&"
import script from "./CourseUpload.vue?vue&type=script&lang=ts&"
export * from "./CourseUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports